import { cookiesService } from '@libs/utils/cookies'
import {
  API_APPLICATION_HOST,
  HTTP_PROTOCOL,
  CLIENT_APP_NAME
} from '@libs/utils/environments'

import { defaultParamsSerializer } from '../../internals'

import { HttpModel } from './httpModel.class'
import type {
  HttpServiceEndpoints,
  HttpClientAuthState
} from './interfaces/HttpClient.interface'

export class HttpSnapApp extends HttpModel {
  private authState: HttpClientAuthState = {
    accountId: cookiesService.readAccountId() as number,
    userId: cookiesService.readUserId() as number
  }

  public core: HttpServiceEndpoints

  public onboarding: HttpServiceEndpoints

  constructor() {
    super(
      {
        baseURL: `${HTTP_PROTOCOL}://${API_APPLICATION_HOST}`,
        paramsSerializer: defaultParamsSerializer,
        withCredentials: true
      },
      {
        ...HttpModel.contentTypes.json,
        'x-snapshift-app': CLIENT_APP_NAME
      }
    )

    this.setupUserInfoHeaders()

    this.core = this.createServiceEndpoints('/api/v2')
    this.onboarding = this.createServiceEndpoints('/gateway/api/onboarding')
  }

  private setupUserInfoHeaders() {
    const headers = {
      'Account-Id': String(this.authState.accountId)
    }

    const impersonatedMembershipId =
      cookiesService.readImpersonatedMembershipId()

    if (impersonatedMembershipId) {
      headers['impersonated-membership-id'] = String(impersonatedMembershipId)
    }

    this.updateHeaders(headers)
  }

  public syncAuthState(authState: Partial<HttpClientAuthState>) {
    this.authState = { ...this.authState, ...authState }
    this.setupUserInfoHeaders()
  }

  get authInfo() {
    return this.authState
  }
}
